import { IParameter, IUnitPrefix } from '@/pages/Parameters/parameters.types.ts'
import { CSSProperties, useMemo } from 'react'
import { useRecoilValue } from 'recoil'
import parametersAtom from '../../parameters.atom'
import { IOption } from '@/types/global'
import DropdownInput from 'src/shared/Inputs/DropdownInput'

interface IProps {
  value: IParameter['unitPrefixId']
  name: string
  onChange: (val: IParameter['unitPrefixId'], name: string) => void
  title?: string
  wrapperStyle?: CSSProperties
}

const ParameterUnitPrefixesDropdown = (props: IProps) => {
  const unitPrefixes = useRecoilValue(parametersAtom).unitPrefixes

  const unitPrefixesOption: IOption<IUnitPrefix['id']>[] = useMemo(() => {
    return unitPrefixes.map((b) => ({ title: b.nameRu, value: b.id }))
  }, [unitPrefixes])

  return (
    <DropdownInput
      name={props.name}
      wrapperStyle={props.wrapperStyle}
      onSelect={props.onChange}
      options={unitPrefixesOption}
      selectedOption={props.value}
      title={props.title || 'Выберите префикс'}
    />
  )
}

export default ParameterUnitPrefixesDropdown
